import Button from 'components/Form/Button';
import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { POST } from 'services/api';
import styled, { keyframes } from 'styled-components';
import { Title } from 'ui/styled';
import { CompanyButtonContainer } from './styled';

// --- Opções de Status de Curadoria: APENAS APROVADO E RECUSADO ---
const statusCuradoriaOptions = [
  { value: 'aprovado', label: 'Aprovado' },
  { value: 'recusado', label: 'Recusado' },
];

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  padding: 0 10px;
  // Ajuste de padding, já que não há textarea
`;

const CuradoriaModalContainer = styled.div`
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px; // Reduzido o max-width já que o conteúdo é menor
  max-height: 85vh;
  overflow-y: auto;
  animation: ${fadeIn} 0.3s ease-out;
`;

const HeaderInfo = styled.div`
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eeeeee;
`;

const BancoTitle = styled(Title)`
  color: #333333;
  font-size: 1.5em;
  font-weight: 600;
  margin-bottom: 5px;
`;

const ActionButtonContainer = styled(CompanyButtonContainer)`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  justify-content: flex-end;

  @media (max-width: 500px) {
    flex-direction: column;
    button {
      width: 100%;
      margin: 5px 0;
    }
  }
`;

const CustomSelect = styled.select`
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
`;

// --- Componente Principal ---
export default function ModalCuradoria({ banco, id, reload, onClose }) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(''); // Estado para o novo status

  // UseMemo para obter o nome do banco
  const bancoNome = useMemo(
    () =>
      banco?.banco?.nome_fantasia ||
      banco?.nome_fantasia ||
      banco?.financial ||
      'Banco',
    [banco]
  );
  const close = () => {
    if (!loading) {
      onClose?.();
    }
  };

  const save = async () => {
    // 1. Validação do Status
    if (!status) {
      toast.error('É obrigatório selecionar o Status!');
      return;
    }
    setLoading(true);
    const payload = {
      // bancoId: banco?.id || banco?.banco?.id || banco,
      propostaId: id,
      status: status,
    };
    try {
      // Endpoint e método POST
      const result = await POST(
        '/financing-proposal/curadoria/statusproposta',
        payload,
        true
      );
      if (result && result.status === 'ok') {
        toast.success(
          `Curadoria para ${bancoNome} salva com sucesso com status '${statusCuradoriaOptions.find((opt) => opt.value === status)?.label}'!`
        );
        if (reload) await reload();
        close();
      } else {
        const errorMessage =
          result?.erro || 'Erro desconhecido na resposta da API.';
        toast.error(`Erro ao atualizar a proposta: ${errorMessage}`);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      toast.error(`Ocorreu um erro ao salvar: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ModalWrapper onClick={close}>
      <CuradoriaModalContainer onClick={(e) => e.stopPropagation()}>
        {/* Informações do Header */}
        <HeaderInfo>
          <BancoTitle small nomargin>
            Curadoria da Proposta
          </BancoTitle>
        </HeaderInfo>
        <ModalContent>
          {/* Campo de Status */}
          <label htmlFor="status">
            Selecione o Status da Curadoria{' '}
            <span style={{ color: 'red' }}>*</span>
          </label>
          <CustomSelect
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            disabled={loading}
          >
            <option value="">Selecione o status</option>
            {statusCuradoriaOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </CustomSelect>
          {/* A observação foi removida daqui */}
        </ModalContent>
        {/* Botões de Ação */}
        <ActionButtonContainer>
          <Button
            onClick={close}
            color="lightgrey"
            border
            nospace
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            color="blue"
            loading={loading}
            onClick={save}
            nospace
            disabled={!status} // Desabilita se o status não estiver selecionado
          >
            Salvar
          </Button>
        </ActionButtonContainer>
      </CuradoriaModalContainer>
    </ModalWrapper>
  );
}
